import onLoad from '../../../javascripts/utils/onLoad';

onLoad<HTMLElement>('.site__header', ($header) => {
  const threshold = 100;

  document.addEventListener('scroll', () => {
    $header.style.setProperty(
      '--site-header-background-opacity',
      Math.min(1, window.scrollY / threshold).toPrecision(4),
    );
  }, { passive: true });
});
